var React = require('react');

function ContactLightGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.42 11.98c-1.631 0-2.96-1.341-2.96-2.99C9.46 7.342 10.79 6 12.42 6c1.632 0 2.96 1.342 2.96 2.99 0 1.649-1.328 2.99-2.96 2.99m0 8.27c-3.506 0-5.42-.868-5.42-1.315 0-2.277 1.682-5.485 5.42-5.485 3.697 0 5.42 3.274 5.42 5.485 0 .447-1.914 1.315-5.42 1.315","fill":"#BEBDB8"}));
}

ContactLightGrey.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = ContactLightGrey;

ContactLightGrey.default = ContactLightGrey;
